import BaseTypo from './Typo';

// EXPORT
export const Typography = BaseTypo;
export type { TypographyProps } from './Typo.interface';
